/**
 * Categorical colours for breakdown bars (validated with the dataviz palette
 * checker: lightness band, chroma, CVD and normal-vision separation, per mode).
 * Four named slots, then "Other": charts never show more than four categories.
 * Every swatch is paired with a visible text label.
 */
export const SERIES = {
  light: ["#65A30D", "#7C6FE0", "#0F9A87", "#D98A1F"],
  dark: ["#65A30D", "#8479E6", "#139A85", "#C98424"],
};
export const OTHER = { light: "#B5BCB7", dark: "#4B524E" };

export function seriesColor(mode: "light" | "dark", index: number, other = false): string {
  return other || index >= 4 ? OTHER[mode] : SERIES[mode][index];
}
